import { render, staticRenderFns } from "./contract-view.vue?vue&type=template&id=208ed388&scoped=true"
import script from "./contract-view.vue?vue&type=script&lang=js"
export * from "./contract-view.vue?vue&type=script&lang=js"
import style0 from "./contract-view.vue?vue&type=style&index=0&id=208ed388&prod&lang=scss&scoped=true"
import style1 from "./contract-view.vue?vue&type=style&index=1&id=208ed388&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208ed388",
  null
  
)

export default component.exports